export const DialogContentSx = {
  padding: 0,
  margin: '28px 0 32px 0',
};
